module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationBar shadowBottom text-center bg-color-1 lightest",
    class: {
      'active': _vm.isUpdateAvailable
    }
  }, [_c('b', [_vm._v("New Update:")]), _vm._v(" more features, improvements and better navigation.\n    "), _c('button', {
    staticClass: "bg-color-1 lightest border-lightest radius-normal ml-4 pointer px-3 btn",
    on: {
      "click": _vm.reloadApp
    }
  }, [_vm._v("Update Now")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7837f295", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7837f295"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/topbarMessage.vue
// module id = 1369
// module chunks = 0